"use client";
import {forwardRef, InputHTMLAttributes} from "react";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

const FormInput = forwardRef<HTMLInputElement, Props>(
  ({label, error, className, ...rest}, ref) => (
    <div className="flex flex-col gap-2 font-mono">
      <label
        htmlFor={rest.id}
        className="text-[10px] font-bold text-zinc-500 uppercase tracking-widest"
      >
        [{label}]
      </label>
      <input
        ref={ref}
        id={rest.id}
        className={`
          w-full px-4 py-2.5 rounded-none border-2 bg-zinc-950 text-zinc-100
          focus:outline-none transition-none
          placeholder:text-zinc-700 text-xs
          ${error ? "border-red-500 focus:border-red-500" : "border-zinc-800 focus:border-yellow-400"}
          ${className || ""}
        `}
        {...rest}
      />
      {error && <p className="text-[10px] text-red-500 font-bold uppercase mt-0.5">&gt;&gt; ERROR: {error}</p>}
    </div>
  ),
);
FormInput.displayName = "FormInput";
export default FormInput;
